var Gyroscope = {

  init: function() {
      var urlParams = new URLSearchParams(window.location.search);
      var sl = urlParams.get('gyro');
      if (sl == "1") {
        Gyroscope.prepare();
      } else {
        Gyroscope.detect();
      }
        //console.log("Gyroscope started");
        //alert("Gyroscope started");
//      }
  },

  getAxisAndAngelFromQuaternion: function(qq) {
    var q = {"x": qq[0], "y": qq[1], "z": qq[2], "w": qq[3]};
    var angle = 2 * Math.acos(q.w);
    var s;
    if (1 - q.w * q.w < 0.000001) {
      s = 1;
    } else { 
      s = Math.sqrt(1 - q.w * q.w);
    }
    return { "axis": {"x": q.x/s, "y": q.y/s,"z": q.z/s}, "angle": angle };
  },

  startStop: function() {
    if (Gyroscope.started == undefined || Gyroscope.started == false) {
      Gyroscope.sensor.start();
      Gyroscope.started = true;
    } else {
      Gyroscope.sensor.stop();
      Gyroscope.started = false;      
    }
  },

  devicemotion: function(event) {
//    console.log("devicemotion");
  //  console.log(event);

    if(event.alpha || event.beta || event.gamma) {
         window.removeEventListener("deviceorientation", Gyroscope.devicemotion);
         Gyroscope.gyroPresent = true;
         Gyroscope.prepare();
    }
  },

  detect: function() {
    if (window.DeviceOrientationEvent) {
      window.addEventListener("deviceorientation", Gyroscope.devicemotion);
    }
  },

  reposition: function() {
    player.cancelIdle();

//        q.fromArray(qq).inverse();
    var rotation = new THREE.Euler().setFromQuaternion(Gyroscope.q, "XYZ");
    //console.log(rotation);
    //console.log("x: " + THREE.Math.radToDeg(rotation.x) + ", y: " + THREE.Math.radToDeg(rotation.y) + ", z: " + THREE.Math.radToDeg(rotation.z));

    //console.log(player.currentView.properties.properties.north);
    //if (player.currentView.renderer.opacity < 1) return; 

    player.currentView.renderer.rx = (THREE.MathUtils.radToDeg(rotation.z) + parseFloat(player.currentView.properties.properties.north) + 90);
    player.currentView.renderer.ry = (-1 * THREE.MathUtils.radToDeg(rotation.x) - 90);
    //console.log(player.currentView.renderer.ry);
    if (player.currentView.renderer.rx > 360) player.currentView.renderer.rx = player.currentView.renderer.rx - 360;
    if (player.currentView.renderer.rx < 0) player.currentView.renderer.rx = player.currentView.renderer.rx + 360;

    if (player.currentView.renderer.ry > 89) player.currentView.renderer.ry = 89;
    if (player.currentView.renderer.ry < -89) player.currentView.renderer.ry = -89;

//    if (HotSpotManager.closest != undefined) HotSpotManager.closest.show();
//    HotSpotManager.closest.speak();

    //console.log(player.currentView.renderer.rx);
  },

  prepare: function() {
    try {
      var options = { frequency: 60, referenceFrame: "screen" };
      var sensor = new AbsoluteOrientationSensor(options);
      Gyroscope.sensor = sensor;

      sensor.addEventListener("reading", function() {
        var qq = sensor.quaternion;
        var q = new  THREE.Quaternion();

        q.fromArray(qq).invert();

        Gyroscope.q = q;
        Gyroscope.qq = qq;

        Gyroscope.reposition();

      });
    } catch(e) {
    }
    
    Promise.all([navigator.permissions.query({ name: "accelerometer" }),
                 navigator.permissions.query({ name: "magnetometer" }),
                 navigator.permissions.query({ name: "gyroscope" })])
           .then(function(results) {
             if (results.every(function(result) {return result.state === "granted";})) {
                WCompass.showGyro(true);
               //sensor.start();
               // …
             } else {
               console.log("No permissions to use AbsoluteOrientationSensor.");
             }
       });
  }
}

PluginManager.add(Gyroscope);
